import { Routes } from '@angular/router';
import { RoutesConstants } from 'src/app/shared/common';

export const PROFILE_ROUTES: Routes = [
  {
    path: RoutesConstants.USER_PROFILE_PAGE_URL,
    loadComponent: () =>
      import('./pages/user-profile-page/user-profile-page.component').then((x) => x.UserProfilePageComponent),
    data: {
      breadcrumb: {
        label: 'USER_PROFILE',
        icon: 'account_box',
      },
    },
  },
];
